const doctorList = {
    tableList: [
        {
            'id': 1,
            'text': 'No',
            'name': 'sNo',
            'visible': true,
            'className': 'text-center'
        },

        // {
        //     'id': 2,
        //     'text': 'Unit',
        //     'visible': true,
        //     'className': null
        // }, {
        //     'id': 3,
        //     'text': 'Unit Location',
        //     'visible': true,
        //     'className': null
        // }, {
        //     'id': 4,
        //     'text': 'Department',
        //     'visible': true,
        //     'className': null
        // },

        {
            'id': 5,
            'text': 'Doctor',
            'name': 'name',
            'visible': true,
            'className': null
        },
        {
            'id': 4,
            'text': 'Doctor Code',
            'name': 'id',
            'visible': true,
            'className': null
        },

        {
            'id': 4,
            'text': 'Department',
            'name': 'departmentname',
            'visible': true,
            'className': null
        },


        {
            'id': 6,
            'text': 'Status',
            'name': 'status',
            'visible': true,
            'className': null
        }, {
            'id': 7,
            'text': 'Action',
            'name': 'action',
            'visible': true,
            'className': null
        }
    ]
};

const doctorForm = {
    feilds: [{
        id: 1,
        name: 'name',
        title: 'Name *',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Enter Name'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },  {
        id: 2,
        name: 'phonenumber',
        title: 'Phone Number',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            // {
            //     test: (value) => {
            //         var phnoreg = /[6789][0-9]{9}/;
            //        return (value !== null && value.length > 0 && value.length < 11 && phnoreg.test(value));
            //    },
            //     message: 'Please Enter valid Phone Number'
            // }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 1,
        name: 'doctorid',
        title: 'Doctor ID *',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Enter Doctor ID'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4'
    }, {
        id: 3,
        name: 'speciality_id',
        title: 'speciality',
        visible: false,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },{
        id: 5,
        name: 'unit_id',
        title: 'Unit *',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Select Unit'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4'
    }, {
        id: 6,
        name: 'department_id',
        title: 'Department / speciality *',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    
                },
                message: 'Please Select Department'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 6,
        name: 'counsellor_id',
        title: 'counsellor',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            // {
            //     test: (value) => {
            //         return (value !== null);
            //         return true;
            //     },
            //     message: 'Please Select counsellor'
            // }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },{
        id: 5,
        name: 'send_whatsapp_sms',
        title: 'Send Whatsapp *',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return value !== null && value.length > 0;
                },
                message: 'Please Select Sent to Whatsapp'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4',
        options: [  // Add options for yes and no
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' }
        ]
    },
    {
        id: 6,
        name: 'care_management',
        title: 'Care Management *',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return value !== null && value.length > 0;
                },
                message: 'Please Select Care Management' 
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4',
        options: [  // Add options for yes and no
            { label: 'Medical', value: 'Medical' },
            { label: 'Surgical', value: 'Surgical' }
        ]
    }
   
    ]
}

export { doctorList, doctorForm };